import React from "react";

import { SystemScreen } from "~/components/system-screen";
import { secondsToMilliseconds } from "~/tools/date-time";
import { max } from "~/tools/max";
import { useInterval } from "~/tools/use-interval";

import { Link } from "../link";

export const LicenseSuccess: React.FC = () => {
	const [countdown, setCountdown] = React.useState(10);

	useInterval(
		() => {
			setCountdown((x) => max(0, x - 1));
		},
		[],
		secondsToMilliseconds(1),
	);

	React.useEffect(() => {
		if (countdown === 0) {
			location.reload();
		}
	}, [countdown]);

	return (
		<SystemScreen
			alertContent="The license key was successfully applied."
			alertVariant="success"
			className="min-h-full"
		>
			We will automatically refresh the page in {countdown}s to activate the new license.{" "}
			<Link className="inline-flex" el="button" onClick={() => location.reload()} theme="secondary" type="button">
				Refresh now
			</Link>
		</SystemScreen>
	);
};
